import {
  Card,
  CardContent,
  Checkbox,
  Grid,
  TextField,
  Typography,
} from "@material-ui/core";
import {
  PaymentConfigsDto,
  StripePaymentConfigDto,
  StripePaymentMethod,
} from "../../../graphql/models/Payments";
import { useEffect, useState } from "react";

export interface PaymentConfigsProps {
  value: PaymentConfigsDto | undefined;
  title?: string;
  onChange: (value: PaymentConfigsDto | undefined) => void;
}

export interface StripePaymentConfigProps {
  value: StripePaymentConfigDto | undefined;
  onChange: (value: StripePaymentConfigDto) => void;
}

export function PaymentConfigs(props: PaymentConfigsProps) {
  const { value, title, onChange } = props;
  const [stripe, setStripe] = useState(value?.stripe);
  const [stripeIsSet, setStripeIsSet] = useState(!!stripe);
  const [firstRound, setFirstRound] = useState(true);

  useEffect(() => {
    if (!firstRound) {
      if (stripeIsSet) onChange({ stripe });
      else onChange(undefined);
    }
    setFirstRound(false);
  }, [stripeIsSet, stripe, onChange]);

  return (
    <Card>
      <CardContent>
        <Typography variant={"h4"}>
          {title ?? "Configura i metodi di pagamento"}
        </Typography>
        <Grid item xs={12} style={{ marginTop: "1em", marginBottom: "1em" }}>
          <Checkbox
            checked={stripeIsSet}
            onChange={(e, v) => setStripeIsSet(v)}
          ></Checkbox>{" "}
          Stripe
        </Grid>
        {stripeIsSet && (
          <StripePaymentConfig value={stripe} onChange={setStripe} />
        )}
      </CardContent>
    </Card>
  );
}

export function StripePaymentConfig(props: StripePaymentConfigProps) {
  const { value, onChange } = props;
  const methods = value?.methods ?? [];

  const [card, setCard] = useState(
    methods?.findIndex((item) => item === StripePaymentMethod.CARD) !== -1
  );
  const [sepa, setSepa] = useState(
    methods?.findIndex((item) => item === StripePaymentMethod.SEPA_DEBIT) !== -1
  );
  const [publicKey, setPublicKey] = useState(value?.publicKey ?? "");
  const [privateKey, setPrivateKey] = useState(value?.privateKey ?? "");

  useEffect(() => {
    const record: StripePaymentConfigDto = {
      methods: [],
      privateKey,
      publicKey,
    };
    if (sepa) record.methods.push(StripePaymentMethod.SEPA_DEBIT);
    if (card) record.methods.push(StripePaymentMethod.CARD);
    onChange(record);
  }, [sepa, card, privateKey, publicKey, onChange]);

  return (
    <>
      <hr></hr>
      <Grid item xs={12}>
        <Typography variant={"h6"}>Configurazione Stripe</Typography>
      </Grid>
      <Grid item md={4} lg={3}>
        <Checkbox checked={card} onChange={(e, v) => setCard(v)}></Checkbox>{" "}
        Carta di credito
      </Grid>
      <Grid item md={4} lg={3}>
        <Checkbox checked={sepa} onChange={(e, v) => setSepa(v)}></Checkbox>{" "}
        Addebito CC (SEPA)
      </Grid>
      <Grid container spacing={2}>
        <Grid item md={4} lg={3}>
          <TextField
            label="Chiave Privata"
            style={{ width: "100%" }}
            variant={"outlined"}
            value={privateKey}
            onChange={(e) => setPrivateKey(e.target.value)}
          ></TextField>
        </Grid>
        <Grid item md={4} lg={3}>
          <TextField
            label="Chiave Pubblica"
            style={{ width: "100%" }}
            variant={"outlined"}
            value={publicKey}
            onChange={(e) => setPublicKey(e.target.value)}
          ></TextField>
        </Grid>
      </Grid>
    </>
  );
}
